"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import Image from "next/image";
import Link from "next/link";
import { ROUTES } from "@/constants";

type ContentfulImage = {
  fields: {
    file: {
      url: string;
      details?: {
        image: {
          width: number;
          height: number;
        };
      };
    };
  };
};

type DocumentHeroProps = {
  content: {
    heroTitle?: string;
    heroDescription: string;
    slug: string;
    heroImage?: ContentfulImage;
    imageWidth?: number;
  };
};

export default function HeroDocument({ content }: DocumentHeroProps) {
  const { heroTitle, heroDescription, heroImage, imageWidth = 602 } = content;

  const imageUrl = heroImage?.fields?.file?.url
    ? `https:${heroImage.fields.file.url}`
    : null;

  const imageDimensions = heroImage?.fields?.file?.details?.image;

  return (
    <section className="section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)]">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-8l g:gap-0 lg:grid-cols-2 py-6 md:py-20">
          <div className="grid grid-cols-1 gap-8 place-content-center">
            <div className="grid grid-cols-1 md:gap-8 gap-4 w-full lg:max-w-[509px]">
              <Typography variant="headingMain">
                <h1>{heroTitle}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{heroDescription}</p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 place-content-start gap-4 sm:flex flex-wrap lg:gap-2.5">
              <Button
                asChild
                variant="primary"
                className="sm:max-w-[247px] h-[48px]"
              >
                <Link href={ROUTES.startOrder} className="!text-base w-full">
                  Start order
                </Link>
              </Button>
            </div>
          </div>

          {imageUrl && (
            <div className="flex">
              <Image
                alt="hero image"
                src={imageUrl}
                width={imageDimensions?.width || 602}
                height={imageDimensions?.height || 516}
                quality={100}
                priority
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
